import { h, render, Component } from 'preact';
import CommonBlock from './commonBlock';
import Utils from '../../utils';

export default class Banner extends CommonBlock {
  render() {
    const banClass = Utils.getCampaignData(this.props.emplacement) ? `Wio${Utils.getCampaignData(this.props.emplacement)}` : '';

    return (
      <div>
        <div
          id="wio_ban"
          style={this.getStyle()}
          className={`WioFloat WioBanner ${banClass}`}
          onClick={()=>{
            if (!Utils.getCampaignData(this.props.exitUrl)  || !this.nobutton) return;
            this.props.refuseBlock();
            window.location.href = Utils.getCampaignData(this.props.exitUrl);
          }}
        >
          <div
            id="wioContent"
            dangerouslySetInnerHTML={{ __html: this.state.content }}
          />
          {this.insertDiscoverButton()}
          <button
            id="wioBlockExit"
            style={this.getExitStyle()}
            onClick={this.closeBlock}
          >
            X
          </button>
        </div>
        {this.insertBellButton()}
      </div>
    )
  };
};
